peekArgs